import { PrismicRichText } from '@prismicio/react';
import ArrowDownSvg from '@remote-com/norma/icons/arrow-down.svg';
import { Hero } from 'remote-com-shared/components/Hero';
import { ContentMain } from 'remote-com-shared/components/Hero/styles';
import { fluidProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';
import { mobileBreakpoint } from '@/src/domains/shared/breakpoints';
import HeroBackgroundImage from '@/src/views/BenefitsDirectory/assets/onboarding-bg.png';

const BenefitsHero = styled(Hero)`
  font-family: var(--typography-fontBossa);
  background-size: cover;
  max-height: auto;
  min-height: auto;
  background-image: url(${HeroBackgroundImage.src});

  ${ContentMain} {
    padding-bottom: 150px;
  }
`;

const Title = styled.div`
  ${fluidProp('font-size', '52px', '85px')}
  font-weight: 700;
  line-height: 1;

  ${mobileBreakpoint(css`
    font-size: 42px;
  `)};

  & > * {
    margin: 0;
  }
`;

const ArrowIcon = styled(ArrowDownSvg)`
  margin-left: 8px;

  ${sharedTransition(`transform`)}
`;

const Link = styled.a`
  display: flex;

  && {
    color: white;
  }

  &:hover {
    ${ArrowIcon} {
      transform: translateY(5px);
    }
  }
`;

export function HeroSlice({ slice }) {
  const { primary } = transformProperties(slice);

  const { title, scrollToLabel } = primary;

  return (
    <BenefitsHero
      title={
        fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )
      }
      actions={
        <>
          <Link href="#benefits-table">
            {scrollToLabel}
            <ArrowIcon />
          </Link>
        </>
      }
    />
  );
}
